<template>
    <div
        class="field-list-conatiner"
        @mouseleave="clearFieldList"
    >
        <p
            v-for="(item, index) in fieldList"
            :key="index"
            @click="selectField(item)"
        >
            {{ item }}
        </p>
    </div>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import $ from 'jquery';
import {
    CLASS_NAME_FIELD_TO_BE_FIXED,
    SELECTOR_FIELD_TO_BE_FIXED,
} from '../constants';

export default {
    props: {
        fieldList: {
            type: Array,
        },
    },
    methods: {
        selectField(item) {
            $(SELECTOR_FIELD_TO_BE_FIXED)
                .text(item)
                .removeClass('error');
            this.clearFieldList();
        },
        clearFieldList() {
            $(SELECTOR_FIELD_TO_BE_FIXED)
                .removeClass(CLASS_NAME_FIELD_TO_BE_FIXED);
            this.$emit('select-field');
        },
    },
};
</script>
